import { CouponFeedback, AppliedCoupon } from './CouponFeedback';
import { BigRadio, BillRow, TextInputWithButton, Loader, Spinner } from './PaymentControls';
import { Notification, BookingLoadErrorContent } from './Notification';
import { registerRenderer } from 'butlerapp-integration/src/components/component.store';
import { SearchAndSelect } from './SearchAndSelect';
import { RadioOrCheckbox } from './RadioOrCheckbox';
import { TextInput, TextAreaInput, EmailInput, NumberInput } from './TextInput';
import { SelectInput } from './SelectInput';
import { Title } from './Title';
import { DateInput, DateTimeInput } from './DateInput';
import { FileInput } from './FileInput';
import { FormButtonsContainer } from './FormButtons';
import { Button } from './Button';
import { TableCellInner } from './TableCellInner';
import { Flex } from './Flex';
import { WizardBodyContainer, WizardRootContainer, WizardSteps } from './Wizard';
import { CourseMeta } from './CourseMeta';
import { CartTable, CartTableRow } from './Cart';
import { AdminBookingRootContainer, BookingFormSection, AdminBookingTheme } from './Layout';
import { AdminFieldSet } from './FieldSet';
import { SuccessContent, OutgoingMessage, Attachments } from './SuccessContent';
import { NoDataToDisplay } from './NoDataToDisplay';
import { HtmlContent } from '~/components/RenderHtml';

registerRenderer('RadioOrCheckboxTitle', Title);
registerRenderer('Title', Title);
registerRenderer('SearchAndSelect', SearchAndSelect);
registerRenderer('RadioOrCheckbox', RadioOrCheckbox);
registerRenderer('TextInput', TextInput);
registerRenderer('TextAreaInput', TextAreaInput);
registerRenderer('SelectInput', SelectInput);
registerRenderer('FileInput', FileInput);
registerRenderer('DateInput', DateInput);
registerRenderer('SplitDateInput', DateInput);
registerRenderer('FormButtonsContainer', FormButtonsContainer);
registerRenderer('Button', Button);
registerRenderer('TableCellInner', TableCellInner);
registerRenderer('Flex', Flex);
registerRenderer('WizardRootContainer', WizardRootContainer);
registerRenderer('WizardSteps', WizardSteps);
registerRenderer('WizardBodyContainer', WizardBodyContainer);
registerRenderer('CourseMeta', CourseMeta);
registerRenderer('CartTable', CartTable);
registerRenderer('CartTableRow', CartTableRow);
registerRenderer('AdminBookingRootContainer', AdminBookingRootContainer);
registerRenderer('BookingFormSection', BookingFormSection);
registerRenderer('FieldSet', AdminFieldSet);
registerRenderer('SuccessContent', SuccessContent);
registerRenderer('SchemaNoDataToDisplay', NoDataToDisplay);

registerRenderer('AdminBookingTheme', AdminBookingTheme);

registerRenderer('EmailInput', EmailInput);
registerRenderer('NumberInput', NumberInput);
registerRenderer('DateTimeInput', DateTimeInput);
registerRenderer('NoDataToDisplay', NoDataToDisplay);
registerRenderer('Notification', Notification);

registerRenderer('BigRadio', BigRadio);
registerRenderer('BillRow', BillRow);
registerRenderer('TextInputWithButton', TextInputWithButton);
registerRenderer('Loader', Loader);
registerRenderer('Spinner', Spinner);

registerRenderer('CouponFeedback', CouponFeedback);
registerRenderer('AppliedCoupon', AppliedCoupon);

registerRenderer('BookingLoadErrorContent', BookingLoadErrorContent);

registerRenderer('OutgoingMessage', OutgoingMessage);
registerRenderer('MessageBody', HtmlContent);

registerRenderer('Attachments', Attachments);
